import { render, staticRenderFns } from "./compensate.vue?vue&type=template&id=4403113b&scoped=true&"
import script from "./compensate.vue?vue&type=script&lang=js&"
export * from "./compensate.vue?vue&type=script&lang=js&"
import style0 from "./compensate.vue?vue&type=style&index=0&id=4403113b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403113b",
  null
  
)

export default component.exports